
export default str => (
  str.replace(/([-_][a-z])/ig, $1 => (
    $1.toUpperCase().replace('-', '').replace('_', '')
  ))
)
